import React from 'react';

interface Props {
  size?: number;
  className?: string;
  viewBox?: string;
}

const RemoteApplicationIcon: React.FC<Props> = ({ size = 16, className, viewBox = '0 0 16 16' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 10.75H15.25V13C15.25 13.6904 14.6904 14.25 14 14.25H2C1.30964 14.25 0.75 13.6904 0.75 13V10.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 11V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V11"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M6 8.00391L10 4.00391M10 4.00391V7.00373M10 4.00391H7.00018"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default RemoteApplicationIcon;
